import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { Layout } from 'antd/lib';

import RutaAutenticada from '../auth/RutaAutenticada';
import ReportePorRango from './reportes/ReportePorRango';
import CargarDeposito from './depositos/cargarDeposito';
import DepositosPorRango from './reportes/DepositosPorRango';
import CrearIngreso from './ingresos/CrearIngreso';
import VerIngresos from './ingresos/VerIngresos';
import CrearPedido from './pedidos/CrearPedido';
import VerPedidos from './pedidos/VerPedidos';
import ConfirmarIngreso from './ingresos/ConfirmarIngreso';
import VerStock from './stock/VerStock';
import VerStockDelDia from './stock/VerStockDelDia';
import IngresosPorRango from './reportes/IngresosPorRango';
import ConfiguracionList from './configuracion/ConfiguracionList';

import VentasPorRango from './reportes/VentasPorRango';
import GenerarReporteRendicion from './rendicion/GenerarReporteRendicion';
import ListarReportesRendicion from './rendicion/ListarReportesRendicion';

import ConfirmarDepositoContravencion from './depositosContravencion/ConfirmarDepositoContravencion';

import CargarDepositoContravencion from './depositosContravencion/CargarDepositoContravencion';
import VerDepositosContravencion from './depositosContravencion/VerDepositosContravencion';

import VerRecibosContravencion from './recibosContravencion/VerRecibosContravencion';

import * as DeclaracionRoles from '../common/DeclaracionRoles';

import CargarStock from './stock/CargarStock';

class Index extends React.PureComponent {
  render() {
    const { Content } = Layout;
    return (
      <Layout
        style={{
          padding: '0 24px 24px',
        }}
      >
        <Content
          style={{
            padding: '0 24px 24px 24px',
            margin: 0,
          }}
        >
          <Switch>
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/sellos/reportes/ventasporfecha`}
              component={ReportePorRango}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/sellos/reportes/ventas`}
              component={VentasPorRango}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/depositos/nuevo`}
              component={CargarDeposito}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${
                this.props.match.url
              }/depositos/reportes/depositosporfecha`}
              component={DepositosPorRango}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/stock/cargar`}
              component={CargarStock}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.SUPERVISOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${
                this.props.match.url
              }/ingresos/reportes/ingresosporfecha`}
              component={IngresosPorRango}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/ingresos/nuevo`}
              component={CrearIngreso}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.FUNCIONARIO,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/ingresos`}
              component={VerIngresos}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/pedidos/nuevo`}
              component={CrearPedido}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/pedidos`}
              component={VerPedidos}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/ingresos/confirmar/:id`}
              component={ConfirmarIngreso}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/stock/reportes/actual`}
              component={VerStock}
              rolesAutorizados={[
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/stock/reportes/delDia`}
              component={VerStockDelDia}
              rolesAutorizados={[
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/reportes/rendicion/generar`}
              component={GenerarReporteRendicion}
              rolesAutorizados={[
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/reportes/rendicion/ver`}
              component={ListarReportesRendicion}
              rolesAutorizados={[
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/configuracion`}
              component={ConfiguracionList}
              rolesAutorizados={[
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.ADMINISTRADOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/depositosContravenciones/nuevo`}
              component={CargarDepositoContravencion}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/depositosContravencion`}
              component={VerDepositosContravencion}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${
                this.props.match.url
              }/depositosContravencion/confirmar/:id`}
              component={ConfirmarDepositoContravencion}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/recibosContravencion`}
              component={VerRecibosContravencion}
              rolesAutorizados={[
                DeclaracionRoles.ADMINISTRADOR,
                DeclaracionRoles.OPERADOR,
                DeclaracionRoles.DESPACHO,
                DeclaracionRoles.FUNCIONARIO,
                DeclaracionRoles.SUPERVISOR,
                DeclaracionRoles.DGJP_DIRECTOR,
              ]}
            />
          </Switch>
        </Content>
      </Layout>
    );
  }
}

Index.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Index;
